import { useCallback, useEffect, useState } from "react";
import { FA_STORAGE_KEY } from "../constants";

export function useFirestoreAdminTheme() {
  const [dark, setDarkState] = useState(() => localStorage.getItem(FA_STORAGE_KEY) === "1");

  const setDark = useCallback((value) => {
    setDarkState(value);
    localStorage.setItem(FA_STORAGE_KEY, value ? "1" : "0");
  }, []);

  const toggle = useCallback(() => setDark(!dark), [dark, setDark]);

  useEffect(() => {
    document.documentElement.classList.toggle("fa-dark-root", dark);
    return () => document.documentElement.classList.remove("fa-dark-root");
  }, [dark]);

  return { dark, setDark, toggle };
}
